<template>
  <div class="hello">
    <div class="upload">
      <b-row class="upload_warp">
        <b-col sm="6" md="2" class="m-b-15" v-for="(item, index) of outSrcInfo" :key="index + 100000">
          <div class="upload_warp_img_div">
            <div class="upload_warp_img_div_top">
              <div class="upload_warp_img_div_text">
                {{configFun(item.url)}}
              </div>
              <img src="./del.png" class="upload_warp_img_div_del" @click="outSrcDel(index)">
            </div>
            <img :src="configFun(item.url)">
          </div>
        </b-col>
        <b-col sm="6" md="2" class="m-b-15" v-for="(item,index) of imgList" :key="index">
          <div class="upload_warp_img_div">
            <div class="upload_warp_img_div_top">
              <div class="upload_warp_img_div_text">
                {{item.file.name}}
              </div>
              <img src="./del.png" class="upload_warp_img_div_del" @click="fileDel(index)">
            </div>
            <img :src="item.file.src">
          </div>
        </b-col>
        <b-col sm="6" md="2" class="m-b-15" @click="fileClick" @drop="drop($event)" @dragenter="dragenter($event)" @dragover="dragover($event)">
          <div class="upload_warp_right text-center pointer">
            <img class="mauto db m-t-10 m-b-5" style="max-width: 64px;width: 40%;" src="./upload.png">
            点击或将图片拖到此处
          </div>
        </b-col>
      </b-row>
      <div class="upload_warp_text">
        <span v-if="limited">共可选{{this.limited}}张图片，</span>已选{{imgList.length + this.outSrcInfo.length}}张图片，共{{bytesToSize(this.size)}}
      </div>
      <input @change="fileChange($event)" type="file" accept="image/png, image/jpeg, image/gif, image/jpg" :id="id" multiple style="display: none"/>
    </div>
  </div>
</template>

<script>
  import ajax from 'utils/ajax.js'
  import openService from 'service/open-service'
  import Config from 'config'
  export default {
    name: 'hello',
    props: {
      type: {
        type: String,
        required: true
      },
      limited: {
        type: Number,
        default: undefined
      },
      maxSize: {
        type: Number,
        default: undefined
      },
      id: {
        type: String,
        default: 'moreUpload_files'
      },
      outSrc: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        limit: this.limited,
        outSrcInfo: [],
        imgList: [],
        size: 0,
        keyArr: []
      }
    },
    watch: {
      outSrc: function () {
        this.getImgInfo()
      }
    },
    created () {
      this.getImgInfo()
    },
    methods: {
      configFun (url) {
        return Config.imageUrl + url
      },
      getSize (data) {
        this.limit = parseInt(this.limited) - parseInt(data.length)
        if (this.limit < 0) this.limit = 0
        this.size = data.map(res => {
          return res.size
        }).reduce((total, num) => {
          return parseInt(total) + parseInt(num)
        })
      },
      getImgInfo () {
        this.outSrc.map(data => {
          return openService.imageFormat(data).then(res => {
            if (res.meta.success) {
              this.outSrcInfo[this.outSrcInfo.length] = {url: data, size: (res.data.image && res.data.image.format.size) || 0}
              this.getSize(this.outSrcInfo)
            }
          })
        })
      },
      // 设置
      fileClick() {
        document.getElementById(this.id).click()
      },
      fileChange(el) {
        if (!el.target.files[0].size) return
        this.fileList(el.target)
        el.target.value = ''
      },
      fileList(fileList) {
        let files = fileList.files
        for (let i = 0; i < files.length; i++) {
          // 判断是否为文件夹
          if (files[i].type !== '') {
            if (files[i].type && (files[i].type).indexOf('image/') !== -1) {
              this.fileAdd(files[i])
            }
          } else {
            this.folders(fileList.items[i])
          }
        }
      },
      // 文件夹处理
      folders(files) {
        let _this = this
        // 判断是否为原生file
        if (files.kind) {
          files = files.webkitGetAsEntry()
        }
        if (files && files.createReader) {
          files.createReader().readEntries(function (file) {
            for (let i = 0; i < file.length; i++) {
              if (file[i].isFile) {
                _this.foldersAdd(file[i])
              } else {
                _this.folders(file[i])
              }
            }
          })
        }
      },
      foldersAdd(entry) {
        let _this = this
        entry.file(function (file) {
          _this.fileAdd(file)
        })
      },
      fileAdd(file) {
        if (this.limit === 0) {
          this.$awn.warning('最多可上传' + this.limited + '张图片！')
        } else if ((file.size / 1024 / 1024) > this.maxSize) {
          this.$awn.warning('上传图片大小不得超过' + this.maxSize + 'M！')
        } else if ((file.type).indexOf('image/') !== -1) {
          if (this.limit !== undefined) this.limit--
          if (this.limit !== undefined && this.limit < 0) return
          // 总大小
          this.size = (this.size / 1) + (file.size / 1)
          // 判断是否为图片文件
          if (file.type.indexOf('image') === -1) {
            file.src = 'wenjian.png'
            this.imgList.push({
              file
            })
          } else {
            let reader = new FileReader()
            let image = new Image()
            let _this = this
            reader.readAsDataURL(file)
            reader.onload = function () {
              file.src = this.result
              image.src = file.src
              image.onload = function() {
                let width = image.width
                let height = image.height
                file.width = width
                file.height = height
                _this.imgList.push({
                  file
                })
                ajax.upload(file, _this.type).then((res) => {
                  _this.keyArr.push(res.data.key)
                  _this.$emit('change', _this.keyArr)
                })
              }
            }
          }
        }
      },
      outSrcDel (index) {
        this.size = this.size - this.outSrcInfo[index].size
        this.outSrcInfo.splice(index, 1)
        this.limit = parseInt(this.limited) - parseInt(this.outSrcInfo.length)
        this.$emit('oldChange', this.outSrcInfo.map(res => {
          return res.url
        }))
      },
      fileDel(index) {
        this.size = this.size - this.imgList[index].file.size// 总大小
        this.imgList.splice(index, 1)
        this.keyArr.splice(index, 1)
        this.$emit('change', this.keyArr)
        if (this.limit !== undefined) this.limit = this.limited - this.imgList.length
      },
      bytesToSize(bytes) {
        if (bytes === 0) return '0 B'
        let k = 1000 // or 1024
        let sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        let i = Math.floor(Math.log(bytes) / Math.log(k))
        return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i]
      },
      dragenter(el) {
        el.stopPropagation()
        el.preventDefault()
      },
      dragover(el) {
        el.stopPropagation()
        el.preventDefault()
      },
      drop(el) {
        el.stopPropagation()
        el.preventDefault()
        this.fileList(el.dataTransfer)
      }
    }
  }
</script>
<style scoped>
  .upload_warp_img_div_del {
    position: absolute;
    top: 6px;
    width: 16px;
    right: 6px;
  }

  .upload_warp_img_div_top {
    position: absolute;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 30px;
    background-color: rgba(0, 0, 0, 0.4);
    line-height: 30px;
    text-align: left;
    color: #fff;
    font-size: 12px;
    text-indent: 6px;
  }

  .upload_warp_img_div_text {
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .upload_warp_img_div>img {
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    margin: 0 auto;
  }

  .upload_warp_img_div {
    padding: 0 !important;
    position: relative;
    height: 100px;
    border: 1px solid #999;
    line-height: 120px;
    background-color: #eee;
    cursor: pointer;
  }

  .upload_warp_img {
    border-top: 1px solid #D2D2D2;
    padding: 14px 0 0 14px;
    overflow: hidden
  }

  .upload_warp_text {
    text-align: left;
    margin-bottom: 10px;
    padding-top: 10px;
    text-indent: 14px;
    border-top: 1px solid #ccc;
    font-size: 14px;
  }

  .upload_warp_right {
    width: 100%;
    border: 1px dashed #999;
    border-radius: 4px;
    color: #999;
    height: 100px;
  }

  .upload_warp_left img {
    margin: 0 auto;
    display: block;
    margin-top: 32px;
  }

  .upload_warp_left {
    float: left;
    width: 40%;
    height: 100%;
    border: 1px dashed #999;
    border-radius: 4px;
    cursor: pointer;
  }

  .upload_warp {
    margin: 0;
    margin-top: 14px;
  }

  .upload {
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 4px;
  }
  .hello {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/upload/more-upload.vue